import React from 'react'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


// We ignore data.title and data.content to display our own text
const ErrorPayPalModal = composeDialogModal({
  name: constants.modals.ErrorPayPal,
  title: ({ data }) => messages.title,
  buttonTitle: messages.button,
  content: ({ data }) => (
    <FormattedMessage {...messages.text} />
  ),
  onOpen: () => {
    // Hide server error modal if payPal error callback is called
    actions.models.modals.close(constants.modals.ServerError)
  },
})


export default ErrorPayPalModal
